import BaseModel from "../default/base-model";
import {Customer} from "./customer";

export enum ForecastType {
    FLEX_DSI = "FLEX_DSI",
    NET = "NET",
}

export const FORECAST_TYPE_LABELS: Record<ForecastType, string> = {
    [ForecastType.FLEX_DSI]: "Flex + DSI",
    [ForecastType.NET]: "Net",
};

export class Forecast extends BaseModel {
    description?: string;
    customer?: Customer;
    customer_name?: string;
    has_analysis?: boolean;
    created_by_user?: string;
    type?: ForecastType;
}
